import CustomForm from './CustomForm';

export type { FormField, FormFieldSize, IFormFieldMap } from './CustomForm';
export { CustomFormField } from './CustomForm';
export default CustomForm;
